<template>
  <div class="p-fluid grid">
    <div class="field col-12 md:col-2">
      <span class="formulario-title">ASIGNADOS</span>
      <ul class="list-none p-0 m-0">
        <li
          v-for="(frmpredefinido, index) in listado_frmpredefinidos"
          :key="index"
          class="formulario-item"
          :class="{
            'formulario-item-selected':
              formularioSelected?.id === frmpredefinido.id,
          }"
          @click="mostrarFormularioSeleccionado(frmpredefinido)"
        >
          <i class="pi pi-file-edit mr-2" style="font-size: 0.8rem"></i>
          <span class="formulario-name">{{
            frmpredefinido.nombre_formulario
          }}</span>
        </li>
      </ul>
      <span class="formulario-title mt-3">NO ASIGNADOS</span>
      <ul class="list-none p-0 m-0">
        <li
          v-for="(formulario, index) in listado_formularios"
          :key="index"
          class="formulario-item formulario-item-nuevo"
          :class="{
            'formulario-item-selected':
              nuevoFormulario.frm_predefinido_id === formulario.id,
          }"
          @click="crearNuevoFormulario(formulario)"
        >
          <i class="pi pi-plus-circle mr-2" style="font-size: 0.8rem"></i>
          <span class="formulario-name">{{ formulario.titulo }}</span>
        </li>
      </ul>
    </div>

    <div class="field col-12 md:col-10" v-if="formularioSelected">
      <div class="grid">
        <div class="p-field col-12 md:col-5">
          <span
            ><strong>MÉDICO: </strong
            >{{ formularioSelected.nombre_medico }}</span
          >
        </div>
        <div class="p-field col-12 md:col-7">
          <span
            ><strong>TÍTULO: </strong
            >{{ formularioSelected.nombre_formulario }}</span
          >
        </div>
        <div class="field col-12 md:col-12">
          <quill-editor
            ref="quillEditor"
            v-model:content="formularioSelected.contenido"
            :options="opcionesQuill"
          />
        </div>
      </div>
    </div>

    <div class="field col-12 md:col-10" v-if="mostrarNuevoFormulario">
      <div class="grid">
        <div class="p-field col-12 md:col-5">
          <span><strong>MÉDICO: </strong></span>
          <Dropdown
            v-model="medicoSelected"
            :options="medicos"
            optionLabel="nombre_completo"
            placeholder="Seleccione un médico"
            optionValue="id"
          />
        </div>
        <div class="p-field col-12 md:col-7">
          <span><strong>TÍTULO: </strong>{{ nuevoFormulario.titulo }}</span>
        </div>
        <div class="field col-12 md:col-12">
          <quill-editor
            ref="quillEditor"
            v-model:content="nuevoFormulario.contenido"
            :options="opcionesQuill"
          />
        </div>
      </div>
    </div>

    <div
      class="field col-12 md:col-12"
      v-if="formularioSelected || mostrarNuevoFormulario"
    >
      <div class="p-fluid formgrid grid justify-content-end mt-1">
        <!-- Firmas para nuevo formulario -->
        <div class="field col-12 mt-3" v-if="mostrarNuevoFormulario">
          <div class="grid">
            <!-- Firma paciente -->
            <div class="field col-12 md:col-2"></div>
            <div class="field col-12 md:col-5">
              <span class="firma-titulo">FIRMA PACIENTE</span>
              <div class="firma-box">
                <canvas ref="canvas" class="canvas-firma"></canvas>
                <Button
                  icon="pi pi-refresh"
                  class="p-button-sm p-button-warning p-button-text firma-btn-limpiar"
                  v-tooltip.top="'Limpiar'"
                  @click="limpiarFirma('canvas')"
                />
              </div>
            </div>
            <!-- Firma tutor -->
            <div class="field col-12 md:col-5">
              <span class="firma-titulo">FIRMA TUTOR / RESPONSABLE</span>
              <div class="firma-box">
                <canvas ref="canvasTutor" class="canvas-firma"></canvas>
                <Button
                  icon="pi pi-refresh"
                  class="p-button-sm p-button-warning p-button-text firma-btn-limpiar"
                  v-tooltip.top="'Limpiar'"
                  @click="limpiarFirma('canvasTutor')"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Firmas para formulario existente -->
        <div class="field col-12 mt-3" v-if="formularioSelected">
          <div class="grid">
            <!-- Firma paciente existente -->
            <div class="field col-12 md:col-2"></div>
            <div class="field col-12 md:col-5">
              <span class="firma-titulo">FIRMA PACIENTE</span>
              <div
                class="firma-box firma-box-img"
                v-if="formularioSelected.firma"
              >
                <img
                  :src="
                    formularioSelected.firma?.startsWith('data:')
                      ? formularioSelected.firma
                      : 'data:image/png;base64,' + formularioSelected.firma
                  "
                  alt="Firma"
                  style="max-height: 100px; max-width: 100%"
                />
              </div>
              <div class="firma-box" v-else>
                <canvas ref="canvasExistente" class="canvas-firma"></canvas>
                <Button
                  icon="pi pi-refresh"
                  class="p-button-sm p-button-warning p-button-text firma-btn-limpiar"
                  v-tooltip.top="'Limpiar'"
                  @click="limpiarFirma('canvasExistente')"
                />
              </div>
            </div>
            <!-- Firma tutor existente o nueva -->
            <div class="field col-12 md:col-5">
              <span class="firma-titulo">FIRMA TUTOR / RESPONSABLE</span>
              <div
                class="firma-box firma-box-img"
                v-if="formularioSelected.firma_tutor"
              >
                <img
                  :src="
                    formularioSelected.firma_tutor?.startsWith('data:')
                      ? formularioSelected.firma_tutor
                      : 'data:image/png;base64,' +
                        formularioSelected.firma_tutor
                  "
                  alt="Firma Tutor"
                  style="max-height: 100px; max-width: 100%"
                />
              </div>
              <div class="firma-box" v-else>
                <canvas
                  ref="canvasTutorExistente"
                  class="canvas-firma"
                ></canvas>
                <Button
                  icon="pi pi-refresh"
                  class="p-button-sm p-button-warning p-button-text firma-btn-limpiar"
                  v-tooltip.top="'Limpiar'"
                  @click="limpiarFirma('canvasTutorExistente')"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-2">
          <Button
            v-if="!mostrarNuevoFormulario"
            label="IMPRIMIR"
            icon="pi pi-print"
            class="p-button-lg p-button-danger"
            @click="imprimirFormulario()"
            :loading="imprimiendo"
          />
        </div>
        <div class="field col-12 md:col-2" v-if="mostrarNuevoFormulario">
          <Button
            label="GUARDAR"
            icon="pi pi-save"
            class="p-button-lg p-button-info"
            @click="guardarFrm()"
            :loading="guardando"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlanTratamientoService from "@/service/PlanTratamientoService";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import SignaturePad from "signature_pad";
import { nextTick } from "vue";

export default {
  emits: ["actualizarListado"],
  components: { QuillEditor },
  props: {
    show: { type: Boolean, default: false },
    datos_frmprefedinidos: {
      type: Array,
      default() {
        return [];
      },
    },
    formulario_predefinidos: {
      type: Array,
      default() {
        return [];
      },
    },
    cliente_id: { type: Number, default: 0 },
    medicos: { type: Array, default: () => [] },
  },
  data() {
    return {
      mostrarModal: this.show,
      listado_frmpredefinidos: this.datos_frmprefedinidos,
      listado_formularios: this.formulario_predefinidos,
      data_cliente_id: this.cliente_id,
      listado_medicos: this.medicos,
      formularioSelected: null,
      opcionesQuill: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ header: 1 }, { header: 2 }],
            [{ header: [1, 2, false] }],
            [{ font: [] }],
            [{ align: [] }],
          ],
        },
      },
      mostrarNuevoFormulario: false,
      nuevoFormulario: {
        frm_predefinido_id: null,
        titulo: "",
        contenido: "",
        firma: "",
        firma_tutor: "",
      },
      signaturePad: null,
      signaturePadTutor: null,
      signaturePadExistente: null,
      signaturePadTutorExistente: null,
      medicoSelected: null,
      guardando: false,
      imprimiendo: false,
    };
  },
  planTratamientoService: null,
  created() {
    this.planTratamientoService = new PlanTratamientoService();
  },
  methods: {
    guardarFrm() {
      this.guardando = true;
      const quill = this.$refs.quillEditor?.getQuill();
      const contenidoDelta = quill ? quill.getContents() : null;
      let datos = {};

      if (this.mostrarNuevoFormulario) {
        if (!this.medicoSelected) {
          this.$toast.add({
            severity: "error",
            summary: "Formulario Consentimiento",
            detail: "Seleccione un médico",
            life: 3000,
          });
          this.guardando = false;
          return;
        }
        datos = {
          cliente_id: this.data_cliente_id,
          frm_predefinido_id: this.nuevoFormulario.frm_predefinido_id,
          medico_id: this.medicoSelected,
          nombre_formulario: this.nuevoFormulario.titulo,
          contenido: contenidoDelta,
          firma: this.signaturePad
            ? this.signaturePad.toDataURL("image/png")
            : "",
          firma_tutor: this.signaturePadTutor
            ? this.signaturePadTutor.toDataURL("image/png")
            : "",
        };
      } else {
        datos = {
          cliente_id: this.data_cliente_id,
          frm_predefinido_id: this.formularioSelected.frm_predefinido_id,
          medico_id: this.formularioSelected.medico_id,
          nombre_cliente: this.formularioSelected.nombre_cliente,
          nombre_medico: this.formularioSelected.nombre_medico,
          nombre_formulario: this.formularioSelected.nombre_formulario,
          contenido: contenidoDelta,
          firma:
            this.formularioSelected.firma ||
            (this.signaturePadExistente && !this.signaturePadExistente.isEmpty()
              ? this.signaturePadExistente.toDataURL("image/png")
              : ""),
          firma_tutor:
            this.formularioSelected.firma_tutor ||
            (this.signaturePadTutorExistente &&
            !this.signaturePadTutorExistente.isEmpty()
              ? this.signaturePadTutorExistente.toDataURL("image/png")
              : ""),
        };
      }

      this.planTratamientoService.guardarFormulario(datos).then((response) => {
        if (response.success == false) {
          this.$toast.add({
            severity: "error",
            summary: "Formulario Consentimiento",
            detail: response.message,
            life: 3000,
          });
          this.guardando = false;
        } else {
          this.$toast.add({
            severity: "success",
            summary: "Formulario Consentimiento",
            detail: response.message,
            life: 3000,
          });
          this.$emit("actualizarListado");
          this.mostrarNuevoFormulario = false;
          this.guardando = false;
          this.mostrarModal = false;
        }
      });
    },
    imprimirFormulario() {
      this.imprimiendo = true;
      let datos = {
        cliente_id: this.data_cliente_id,
        frm_predefinido_id: this.formularioSelected
          ? this.formularioSelected.frm_predefinido_id
          : null,
      };
      this.planTratamientoService.imprimirFrmConcentimiento(datos).then(() => {
        this.imprimiendo = false;
      });
    },
    crearNuevoFormulario(formulario) {
      this.formularioSelected = null;
      this.mostrarNuevoFormulario = true;
      if (formulario) {
        this.nuevoFormulario.titulo = formulario.titulo;
        this.nuevoFormulario.frm_predefinido_id = formulario.id;
        this.cargarQuillEditor(formulario.contenido);
        this.cargarCanvas();
      }
    },
    mostrarFormularioSeleccionado(frmpredefinido) {
      this.mostrarNuevoFormulario = false;
      this.formularioSelected = frmpredefinido;
      if (frmpredefinido) {
        this.cargarQuillEditor(frmpredefinido.contenido);
        // Si le falta alguna firma inicializar canvas
        if (!frmpredefinido.firma || !frmpredefinido.firma_tutor) {
          this.cargarCanvas();
        }
      }
    },
    cargarQuillEditor(contenido) {
      this.$nextTick(() => {
        const quillEditor = this.$refs.quillEditor;
        if (quillEditor && quillEditor.getQuill) {
          if (typeof contenido === "string") {
            try {
              contenido = JSON.parse(contenido);
            } catch (error) {
              console.error("Error al parsear el contenido:", error);
              return;
            }
          }

          if (Array.isArray(contenido)) {
            const ops = [];
            contenido.forEach((item, index) => {
              const esBold = item.attributes?.bold;
              const anterior = index > 0 ? contenido[index - 1] : null;

              if (
                esBold &&
                index > 0 &&
                !String(anterior?.insert ?? "").endsWith("\n")
              ) {
                ops.push({ insert: "\n" });
              }

              ops.push({
                insert:
                  item.insert === null || item.insert === ""
                    ? "\n"
                    : item.insert,
                ...(item.attributes ? { attributes: item.attributes } : {}),
              });

              if (esBold && !String(item.insert ?? "").endsWith("\n")) {
                ops.push({ insert: "\n" });
              }
            });

            quillEditor.getQuill().setContents(ops);
          }
        }
      });
    },
    cargarCanvas() {
      nextTick(() => {
        // Canvas para nuevo formulario
        const canvas = this.$refs.canvas;
        if (canvas) {
          canvas.width = canvas.offsetWidth || 300;
          canvas.height = 100;
          this.signaturePad = new SignaturePad(canvas);
        }
        const canvasTutor = this.$refs.canvasTutor;
        if (canvasTutor) {
          canvasTutor.width = canvasTutor.offsetWidth || 300;
          canvasTutor.height = 100;
          this.signaturePadTutor = new SignaturePad(canvasTutor);
        }
        // Canvas para formulario existente sin firma
        const canvasExistente = this.$refs.canvasExistente;
        if (canvasExistente) {
          canvasExistente.width = canvasExistente.offsetWidth || 300;
          canvasExistente.height = 100;
          this.signaturePadExistente = new SignaturePad(canvasExistente);
        }
        const canvasTutorExistente = this.$refs.canvasTutorExistente;
        if (canvasTutorExistente) {
          canvasTutorExistente.width = canvasTutorExistente.offsetWidth || 300;
          canvasTutorExistente.height = 100;
          this.signaturePadTutorExistente = new SignaturePad(
            canvasTutorExistente,
          );
        }
      });
    },
    limpiarFirma(ref) {
      if (ref === "canvas" && this.signaturePad) this.signaturePad.clear();
      else if (ref === "canvasTutor" && this.signaturePadTutor)
        this.signaturePadTutor.clear();
      else if (ref === "canvasExistente" && this.signaturePadExistente)
        this.signaturePadExistente.clear();
      else if (
        ref === "canvasTutorExistente" &&
        this.signaturePadTutorExistente
      )
        this.signaturePadTutorExistente.clear();
    },
    ocultarDialog() {
      this.mostrarModal = false;
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    datos_frmprefedinidos(val) {
      this.listado_frmpredefinidos = val;
    },
    medicos: {
      handler(val) {
        this.listado_medicos = val;
        if (val && val.length === 1 && !this.medicoSelected) {
          this.medicoSelected = val[0].id;
        }
      },
      immediate: true,
    },
    formulario_predefinidos(val) {
      this.listado_formularios = val;
    },
    cliente_id(val) {
      this.data_cliente_id = val;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

ul {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 500;
  max-height: 500px;
  overflow-y: auto;
}

.formulario-title {
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  display: block;
  margin-bottom: 8px;
  color: #002236;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  padding: 8px;
  border-radius: 5px;
}

.formulario-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin: 4px;
  border-radius: 6px;
  border: 1.5px solid #ddd;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
}

.formulario-item:hover {
  background-color: #f8f9fa;
  border-color: #002236;
  transform: translateX(3px);
}

.formulario-item-selected {
  background: linear-gradient(135deg, #002236 0%, #004466 100%) !important;
  border-color: #002236 !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 34, 54, 0.3);
}

.formulario-item-selected .formulario-name {
  color: #fff !important;
  font-weight: bold;
}

.formulario-item-selected i {
  color: #ffd700 !important;
}

.formulario-item-nuevo {
  border-style: dashed;
  border-color: #4caf50;
}

.formulario-item-nuevo:hover {
  background-color: #e8f5e9;
  border-color: #4caf50;
}

.formulario-name {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  color: #333;
  line-height: 1.3;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.canvas-wrapper {
  width: 100%;
  flex: 1;
}

.canvas {
  border: 1px solid #002236;
  border-radius: 4px;
  width: 100% !important;
  display: block;
}

.firma-titulo {
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  display: block;
  margin-bottom: 8px;
  color: #002236;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  padding: 8px;
  border-radius: 5px;
}

.firma-box {
  border: 1px solid #002236;
  border-radius: 6px;
  padding: 6px;
  position: relative;
  background: #fff;
  min-height: 100px;
}

.firma-box-img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.canvas-firma {
  width: 100% !important;
  height: 100px;
  display: block;
  border-radius: 4px;
}

.firma-btn-limpiar {
  position: absolute;
  bottom: 4px;
  right: 4px;
  opacity: 0.7;
}
</style>
